<template>
  <div class="content component-users">
    <ol class="breadcrumb pull-right">
      <li class="breadcrumb-item">
        <a href="javascript:;">Home</a>
      </li>
      <li class="breadcrumb-item active">{{ $t('invoiceReferrals.subtitle') }}</li>
    </ol>
    <h1 class="page-header">
      {{ $t('app.name') }}
      <small>{{ $t('invoiceReferrals.subtitle') }}</small>
    </h1>

    <b-row>
      <b-col cols="12">
        <ct-invoice-referral-widget/>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import CtInvoiceReferralWidget from '@/components/InvoiceReferrals/InvoiceReferralsWidget.vue';

export default {
  name: 'InvoiceReferrals',
  components: {
    CtInvoiceReferralWidget,
  },
};
</script>

<style scoped lang="scss">

</style>
